import { transferIncAmountCountryWise } from "../constants/transfersAmount";

interface SearchCriteria {
  searchCriteria: {
    destination: {
      'Display Name #1': string;
    };
    child_age?: Array<{ [key: string]: string }>;
  };
}

export const roundPrice: any = (price: string, displayOnlyNumber?: boolean) => {
  let amount: number = Number(price);
  let [dollars, cent]: string[] = String(price).split(".");
  const cents = Number(cent);

  if (dollars !== "undefined") {
    const lastDigit = Number(dollars?.charAt(dollars.length - 1));

    if (lastDigit < 5) {
      for (let i = lastDigit; i < 5; i++) {
        amount++;
      }
    } else if (lastDigit === 5 && !Boolean(cents)) {
      amount = Number(dollars);
    } else if (lastDigit === 9 && Boolean(cents)) {
      for (let i = lastDigit; i < lastDigit + 6; i++) {
        amount++;
      }
    } else if ((lastDigit === 5 && cents !== 0) || lastDigit > 5) {
      for (let i = lastDigit; i < 9; i++) {
        amount++;
      }
    } else {
      // console.log({ lastDigit }, { cents }, { price }, 'invalid');
    }
    let [newAmount] = String(amount).split(".");
    return displayOnlyNumber
      ? Number(newAmount)
      : String(Number(newAmount).toFixed(0));
  }
};
const normalize = (str: string) =>
  str
    .toLowerCase()
    .replace(/[()-]/g, '')
    .replace(/,/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

const tokenize = (str: string) => normalize(str).split(' ');
export const roundPriceTransfers = (
  price: string | number,
  isAdded: boolean | undefined,
  totalGuest: number,
  flighRoom: SearchCriteria,
  exchangeRate: string
) => {
  const priceString = typeof price === 'string' ? price : price.toString();
  const value = parseFloat(priceString)

  if (isAdded) {
    const today = new Date();
    if (value == 0) {
      return value;
    }
    const destTokens = tokenize(flighRoom?.searchCriteria?.destination["Display Name #1"]);

    const scoredTransfers = transferIncAmountCountryWise?.map((t) => {
      const countryTokens = tokenize(t?.country?.toLowerCase());
      const score = countryTokens?.reduce((acc, token) => {
        return acc + (destTokens?.includes(token) ? 1 : 0);
      }, 0);
      return { ...t, score };
    });

    const filterTransfers = scoredTransfers
      .filter(t => t?.score > 0)
      .filter(t => {
        const from = new Date(t?.dateFrom);
        const to = new Date(t?.dateTo);
        return today >= from && today <= to;
      })
      .sort((a, b) => b?.score - a?.score);

    if (filterTransfers?.length === 0) {
      return value;
    }
    const filterTransfer = filterTransfers?.[0];

    let addAmount = 0;
    if (filterTransfer?.currency !== "GBP") {
      addAmount = filterTransfer?.fXYQ * parseFloat(exchangeRate);
    } else {
      addAmount = filterTransfer.fXYQ;
    }

    let total = 0;
    let childTotal = 0;
    let matchingChildren = 0;

    if (
      flighRoom?.searchCriteria?.child_age &&
      Array.isArray(flighRoom?.searchCriteria?.child_age) &&
      filterTransfer?.childRange !== "0"
    ) {
      const [minAgeStr, maxAgeStr] = filterTransfer.childRange?.split('-');
      const minAge = parseInt(minAgeStr, 10);
      const maxAge = maxAgeStr ? parseInt(maxAgeStr, 10) : minAge;

      flighRoom.searchCriteria.child_age?.forEach((child) => {
        Object.values(child)?.forEach((ageStr) => {
          const age = parseInt(ageStr, 10);
          if (!isNaN(age) && age >= minAge && age <= maxAge) {
            matchingChildren += 1;
          }
        });
      });
      if (filterTransfer.currency !== "GBP") {
        childTotal += (filterTransfer?.childFxyq * parseFloat(exchangeRate)) * matchingChildren;
      } else {
        childTotal += filterTransfer?.childFxyq * matchingChildren;
      }

    }

    const adultCount =
      totalGuest > 1
        ? Math.abs(totalGuest - 3)
        : totalGuest;

    const adultCost = addAmount * adultCount;
    // Step 6: Final total
    total = value + adultCost + childTotal;
    return total;
  };

  return value;
};

